import faker from '@faker-js/faker';
import loopMap from 'mn-utils/loopMap';
import {TWithdrawsItem} from './types';

export const getWithdrawalList = (limit: number): TWithdrawsItem[] => {
  return loopMap(limit, getWithdrawal) as TWithdrawsItem[];
};

export const getWithdrawal = (): TWithdrawsItem => {
  const statuses = ['done', 'active', 'failed', 'on_hold', 'unknown'];

  return {
    id: faker.datatype.uuid(),
    time: faker.date.recent().toISOString(),
    bank_name: faker.finance.accountName(),
    status: (faker.helpers as any).arrayElement(statuses),
    amount: faker.finance.amount(100, 10000, 2),
  } as TWithdrawsItem;
};
